import React from "react";
import Icon, { type IconProps } from "./Icon";

/**
 * X icon — vendored from Lucide.
 * Source: https://lucide.dev/icons/x (MIT). Copied 2026-05-16.
 *
 * Phase 2c: replaces Banner + Drawer dismiss buttons' `✕` Unicode glyph.
 */
export default function X(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </Icon>
  );
}
